import { useEffect, useState } from 'react';

const navItems: { id: string; label: string }[] = [
  { id: 'facts', label: '影片档案' },
  { id: 'plot', label: '剧情介绍' },
  { id: 'cast', label: '演员表' },
  { id: 'series', label: '系列续集' },
  { id: 'scenes', label: '经典片段' },
  { id: 'similar', label: '类似电影' },
  { id: 'guide', label: '观影指南' },
  { id: 'faq', label: '常见问题' },
];

const tickerItems: string[] = [
  '资料更新：2026 年 10 月',
  '已收录系列作品 3 部',
  '同类推荐 6 部',
  '演员阵容 11 位',
  '经典片段 5 段',
  '含分级提示，请成年观众阅读',
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const headerBg = scrolled
    ? 'bg-background-50/90 backdrop-blur border-b border-background-200'
    : 'bg-transparent border-b border-transparent';
  const textColor = scrolled ? 'text-foreground-950' : 'text-background-50';

  return (
    <header className={`fixed left-0 top-0 z-50 w-full transition-colors duration-300 ${headerBg}`}>
      <div
        className={`overflow-hidden bg-foreground-950 text-background-100 transition-all duration-300 ${
          scrolled ? 'max-h-0 opacity-0' : 'max-h-10 opacity-100'
        }`}
      >
        <div className="flex items-center gap-2 px-4 py-2 font-label text-xs md:px-8">
          <span className="flex items-center justify-center w-4 h-4 shrink-0 text-primary-400">
            <i className="ri-megaphone-line" />
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track">
              {[0, 1].map((dup) => (
                <span key={dup} className="inline-flex items-center">
                  {tickerItems.map((item) => (
                    <span key={`${dup}-${item}`} className="inline-flex items-center">
                      <span className="px-4 text-background-100/85">{item}</span>
                      <span className="text-primary-500">·</span>
                    </span>
                  ))}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between px-4 md:px-8">
        <a href="#top" className={`flex items-center gap-2 py-4 font-heading text-base font-semibold md:text-lg ${textColor}`}>
          <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line" />
          </span>
          <span className="whitespace-nowrap">蜜桃成熟时电影</span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`rounded-md px-3 py-2 font-label text-sm whitespace-nowrap transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  : 'text-background-100/90 hover:bg-white/10 hover:text-background-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#plot"
            className="hidden items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-play-circle-line" />
            查看剧情
          </a>
          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className={`flex items-center justify-center w-10 h-10 rounded-md border lg:hidden ${
              scrolled ? 'border-background-300 text-foreground-900' : 'border-white/30 text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}